import { useNavigate } from "react-router-dom";
import { EventExpenseWrapper } from "../../../Styles/ExpenseStyle";

const EventExpensesPage = () => {
    const navigate = useNavigate();

    const handleFolderClick = (event) => {
        if (event.target.closest(".folder_box")) {
            navigate("/admin/accounting/event-details");
        }
    }

    return(
        <>
            <EventExpenseWrapper>
                <div className="folder_section" onClick={handleFolderClick}>
                    <div className="folder_box">
                        <div className="box_inner">
                            <div className="img_sec">
                                <img src="/images/folder1.png" alt="" />
                            </div>
                            <p>Festival</p>
                            <a><i className="fa-solid fa-circle"></i>Active</a>
                        </div>
                    </div>
                    <div className="folder_box">
                        <div className="box_inner">
                            <div className="img_sec">
                                <img src="/images/folder1.png" alt="" />
                            </div>
                            <p>Festival</p>
                            <a className="cancel"><i className="fa-solid fa-circle"></i>Cancel</a>
                        </div>
                    </div>
                    <div className="folder_box">
                        <div className="box_inner">
                            <div className="img_sec">
                                <img src="/images/folder1.png" alt="" />
                            </div>
                            <p>Festival</p>
                            <a className="conclude"><i className="fa-solid fa-circle"></i>Conclude</a>
                        </div>
                    </div>
                    <div className="folder_box">
                        <div className="box_inner">
                            <div className="img_sec">
                                <img src="/images/folder1.png" alt="" />
                            </div>
                            <p>Festival</p>
                            <a className="active"><i className="fa-solid fa-circle"></i>Active</a>
                        </div>
                    </div>
                    <div className="folder_box">
                        <div className="box_inner">
                            <div className="img_sec">
                                <img src="/images/folder1.png" alt="" />
                            </div>
                            <p>Festival</p>
                            <a className="cancel"><i className="fa-solid fa-circle"></i>Cancel</a>
                        </div>
                    </div>
                    <div className="folder_box">
                        <div className="box_inner">
                            <div className="img_sec">
                                <img src="/images/folder1.png" alt="" />
                            </div>
                            <p>Festival</p>
                            <a className="conclude"><i className="fa-solid fa-circle"></i>Conclude</a>
                        </div>
                    </div>
                    <div className="folder_box">
                        <div className="box_inner">
                            <div className="img_sec">
                                <img src="/images/folder1.png" alt="" />
                            </div>
                            <p>Festival</p>
                            <a className="active"><i className="fa-solid fa-circle"></i>Active</a>
                        </div>
                    </div>
                    <div className="folder_box">
                        <div className="box_inner">
                            <div className="img_sec">
                                <img src="/images/folder1.png" alt="" />
                            </div>
                            <p>Festival</p>
                            <a className="conclude"><i className="fa-solid fa-circle"></i>Conclude</a>
                        </div>
                    </div>
                    <div className="folder_box">
                        <div className="box_inner">
                            <div className="img_sec">
                                <img src="/images/folder1.png" alt="" />
                            </div>
                            <p>Festival</p>
                            <a className="cancel"><i className="fa-solid fa-circle"></i>Cancel</a>
                        </div>
                    </div>
                </div>
            </EventExpenseWrapper>
        </>
    )
}

export default EventExpensesPage;
